import { observer } from 'mobx-react';
import React from 'react';
import { InputWithTextInside } from '~/view/components/Controls/Inputs';
import './style.scss';

interface IEditPriceProps {
  value: number | string;
  currency: string;
  disabled?: boolean;
  onChangePrice: (price: number | string) => void;
}

const EditPrice: React.FC<IEditPriceProps> = observer(({ value, currency, disabled, onChangePrice }: IEditPriceProps): JSX.Element => {
  const handlePriceChange = (value: string | undefined) => {
    onChangePrice(value ?? 0);
  };

  return (
    <InputWithTextInside
      type="floatNumber"
      name="text"
      value={value}
      onChangeValue={handlePriceChange}
      textProps={{ text: currency }}
      placeholder="0"
      maxLength={10}
      contentClassName="edit-price__input-wrapper"
      disabled={disabled}
    />
  );
});

export default EditPrice;
